import catStill from '../images/cat_still.gif';
import catTalking from '../images/cat.gif';
import dogStill from '../images/dog_still.gif';
import dogTalking from '../images/dog.gif';
import fishStill from '../images/fish_still.gif';
import fishTalking from '../images/fish.gif';
import foxStill from '../images/fox_still.gif';
import foxTalking from '../images/fox.gif';
import pencilStill from '../images/pencil_still.gif';
import pencilTalking from '../images/pencil.gif';
import standingDogStill from '../images/standingDog_still.gif';
import standingDogTalking from '../images/standingDog.gif';

const Puppets = {
    Cat: {
        still: catStill,
        talking: catTalking,
    },
    Dog: {
        still: dogStill,
        talking: dogTalking,
    },
    Fish: {
        still: fishStill,
        talking: fishTalking,
    },
    Fox: {
        still: foxStill,
        talking: foxTalking,
    },
    Pencil: {
        still: pencilStill,
        talking: pencilTalking,
    },
    'Standing Dog': {
        still: standingDogStill,
        talking: standingDogTalking,
    },
};

export default Puppets;
